/* eslint-disable no-useless-concat */
/* eslint-disable no-restricted-globals */

const formatHost = (host: string) => {
  if(location.host.indexOf('www.') === 0){
    return location.host.replace('www.','')
  }

  return host
}

export const sitePath = `${window.location.origin}`
export const siteHost = `${formatHost(window.location.host)}`

export const apiPath =process.env.REACT_APP_RHYBUS_API_URL + '/api'

export const fetchProvider = {
  Headers,
  Request,
  Response,
  fetch: window.fetch.bind(window),
}


